<script>
import HoriBarChart from './HoriBarChart';

  export default {
    name: 'drilldown-hori-bar-chart',
    extends: HoriBarChart,
    props: ['path'],

    methods: {
      fillData () {
        var self = this;
        var chartData = self.chartData.getChild(self.path).getChartJsData();
        chartData = self.formatData(chartData);

        self.options.onClick = function(click, chartBar) {
          if (!chartBar.length)
            return;

          var label = chartBar[0]._model.label;
          self.pushToPath(label);
        };

        self.renderChart({
          labels: chartData.labels,
          datasets: [{
            backgroundColor: "rgb(169, 221, 183)",
            data: chartData.data
          }]
        }, self.options);
      },

      updateData () {
        var self = this;

        var chart = self.$data._chart;
        var chartData = self.chartData.getChild(self.path).getChartJsData();
        chartData = self.formatData(chartData);

        chart.data.labels = chartData.labels;
        chart.data.datasets[0].data = chartData.data;
        chart.update();
      },

      pushToPath (newPathLevel) {
        var self = this;

        if (self.chartData.getChild(self.path.concat(newPathLevel)).numChildren())
          self.path.push(newPathLevel);
      },

      formatData (chartData) {
        // sorts the data and only takes the top 10

        var labels = chartData.labels,
            data = chartData.data;

        var zippedData = d3.zip(labels, data);
        zippedData.sort(function(a, b) {
          return b[1] - a[1];
        });

        zippedData = zippedData.slice(0, 10);

        return {
          labels: zippedData.map(function(d) { return d[0]; }),
          data: zippedData.map(function(d) { return d[1]; })
        };
      }
    },

    watch: {
      'path': function() {
        var self = this;
        self.updateData();
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DrilldownHoriBarChart.vue